import React from 'react';
import LegalLayout from '../../layouts/LegalLayout/LegalLayout';
import styles from './Legal.module.scss';

const PrivacyNotice = () => {
    return (
        <LegalLayout title="Privacy Notice">
            <div className={styles.legalContent}>
                <section className={styles.section}>
                    <h2>FACTS</h2>
                    <h3>WHAT DOES THIRD NATIONAL (“ISSUER”) DO WITH YOUR PERSONAL INFORMATION?</h3>

                    <div className={styles.importantNote}>
                        <p>
                            <strong>Why?</strong> Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share, and protect your personal information. Please read this notice carefully to understand what we do.
                        </p>
                    </div>

                    <div className={styles.importantNote}>
                        <p>
                            <strong>What?</strong> The types of personal information we collect and share depend on the product or service you have with us. This information can include:
                        </p>
                        <ul>
                            <li>Social Security number and date of birth</li>
                            <li>Account balances and payment history</li>
                            <li>Credit history and credit scores</li>
                        </ul>
                        <p>When you are no longer our customer, we continue to share your information as described in this notice.</p>
                    </div>

                    <div className={styles.importantNote}>
                        <p>
                            <strong>How?</strong> All financial companies need to share customers’ personal information to run their everyday business. In the section below, we list the reasons financial companies can share their customers’ personal information; the reasons Issuer chooses to share; and whether you can limit this sharing.
                        </p>
                    </div>

                    <table className={styles.disclosureTable}>
                        <thead>
                            <tr>
                                <th>Reasons we can share your personal information</th>
                                <th>Does Issuer share?</th>
                                <th>Can you limit this sharing?</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={styles.labelCell}>For our everyday business purposes— such as to process your transactions, maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus</td>
                                <td>YES</td>
                                <td>NO</td>
                            </tr>
                            <tr>
                                <td className={styles.labelCell}>For our marketing purposes— to offer our products and services to you</td>
                                <td>YES</td>
                                <td>NO</td>
                            </tr>
                            <tr>
                                <td className={styles.labelCell}>For joint marketing with other financial companies</td>
                                <td>YES</td>
                                <td>NO</td>
                            </tr>
                            <tr>
                                <td className={styles.labelCell}>For our affiliates’ everyday business purposes— information about your transactions and experiences</td>
                                <td>YES</td>
                                <td>NO</td>
                            </tr>
                            <tr>
                                <td className={styles.labelCell}>For our affiliates’ everyday business purposes— information about your creditworthiness</td>
                                <td>NO</td>
                                <td>WE DON’T SHARE</td>
                            </tr>
                            <tr>
                                <td className={styles.labelCell}>For our affiliates to market to you</td>
                                <td>NO</td>
                                <td>WE DON’T SHARE</td>
                            </tr>
                            <tr>
                                <td className={styles.labelCell}>For nonaffiliates to market to you</td>
                                <td>NO</td>
                                <td>WE DON’T SHARE</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className={styles.importantNote}>
                        <p><strong>Questions?</strong> Call (385) 600-7758 or go to <a href="https://user.stbl.io/auth/help/">https://user.stbl.io/auth/help/</a></p>
                    </div>

                    <hr className={styles.divider} />


                    <h3>Who we are</h3>
                    <table className={styles.disclosureTable}>
                        <tbody>
                            <tr>
                                <td className={styles.labelCell}>Who is providing this notice?</td>
                                <td>Issuer</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3>What we do</h3>
                    <table className={styles.disclosureTable}>
                        <tbody>
                            <tr>
                                <td className={styles.labelCell}>How does Issuer protect my personal information?</td>
                                <td>To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings.</td>
                            </tr>
                            <tr>
                                <td className={styles.labelCell}>How does Issuer collect my personal information?</td>
                                <td>
                                    We collect your personal information, for example, when you
                                    <ul>
                                        <li>open an account or perform transactions</li>
                                        <li>pay your bills or reload funds</li>
                                        <li>use your card</li>
                                    </ul>
                                    We may also collect your personal information from others, such as credit bureaus, affiliates, and other companies.
                                </td>
                            </tr>
                            <tr>
                                <td className={styles.labelCell}>Why can’t I limit all sharing?</td>
                                <td>
                                    Federal law gives you the right to limit only
                                    <ul>
                                        <li>sharing for affiliates’ everyday business purposes—information about your creditworthiness</li>
                                        <li>affiliates from using your information to market to you</li>
                                        <li>sharing for nonaffiliates to market to you</li>
                                    </ul>
                                    State laws and individual companies may give you additional rights to limit sharing. See below for more on your rights under state law.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h3>Definitions</h3>
                    <table className={styles.disclosureTable}>
                        <tbody>
                            <tr>
                                <td className={styles.labelCell}>Affiliates</td>
                                <td>
                                    Companies related by common ownership or control. They can be financial and nonfinancial companies.
                                    <ul>
                                        <li>Issuer does share with our affiliates.</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td className={styles.labelCell}>Nonaffiliates</td>
                                <td>
                                    Companies not related by common ownership or control. They can be financial and nonfinancial companies.
                                    <ul>
                                        <li>Issuer does not share with nonaffiliates so they can market to you.</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td className={styles.labelCell}>Joint marketing</td>
                                <td>
                                    A formal agreement between nonaffiliated financial companies that together market financial products or services to you.
                                    <ul>
                                        <li>Issuer may partner with certain non-affiliated financial companies to offer financial products and services to you.</li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h3>Other important information</h3>
                    <div className={styles.mlaDisclosure}>
                        <p><strong>California and Vermont:</strong> In accordance with state law, we will not share your personal information with nonaffiliates except as permitted by law, including for example, for our own marketing purposes, for everyday business purposes, such as servicing your account, or with your consent.</p>
                        <br />
                        <p><strong>Nevada:</strong> You are being provided this notice pursuant to Nevada law. You may be placed on our internal Do Not Call List by following the directions in the To Limit our Sharing section above. Nevada law requires that we provide you with the following contact information: Bureau of Consumer Protection, Office of the Nevada Attorney General, 555 E. Washington Ave., Suite 3900, Las Vegas, NV 89101; Phone number: 702-486-3132; email: agInfo@ag.nv.gov</p>
                        <br />
                        <p><strong>North Dakota:</strong> In accordance with North Dakota law, we will not share information we collect about you with companies outside of our corporate family, except as permitted by law, including, for example, with your consent, to service your account. Residents of North Dakota are opted out from nonaffiliate marketing by default. We will limit sharing among our companies to the extent required by North Dakota law.</p>
                    </div>
                </section>
            </div>
        </LegalLayout>
    );
};

export default PrivacyNotice;
